// import React from "react";

// const DeleteModal = ({
//   isOpen,
//   onClose,
//   onDelete,
//   fileName,
//   loading,
//   deleteSuccess,
// }) => {
//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
//       <div className="document-popup-box-delete">
//       <h2 className="" style={{ marginLeft: "50px" }}>
//   Are you sure you want to delete the selected item(s)?
// </h2>
//  <p style={{ marginLeft: "20px" }}>
//           The selected item(s) will be removed from this folder. This action
//           cannot be undone.
//         </p>
//         <div
//           style={{
//             display: "flex",
//             gap: "8px",
//             justifyContent: "center",
//             marginTop: "20px",
//           }}
//         >
//           <button
//             onClick={() => onClose(null)}
//             disabled={loading || deleteSuccess}
//             style={{
//               width: "25%",
//               padding: "8px",
//               border: "1px solid #C95EBE",
//               borderRadius: "6px",
//               color: "#C95EBE",
//               fontSize: "15px",
//               fontFamily: "Outfit",
//               fontWeight: "500",
//               background: "transparent",
//               cursor: loading || deleteSuccess ? "not-allowed" : "pointer",
//               opacity: loading || deleteSuccess ? "0.5" : "1",
//               transition: "all 0.2s ease",
//             }}
//             onMouseEnter={(e) => {
//               if (!loading && !deleteSuccess) {
//                 e.target.style.background = "rgba(187, 66, 174, 0.1)";
//                 e.target.style.borderColor = "#C95EBE";
//                 e.target.style.color = "#C95EBE";
//               }
//             }}
//             onMouseLeave={(e) => {
//               if (!loading && !deleteSuccess) {
//                 e.target.style.background = "transparent";
//                 e.target.style.borderColor = "#C95EBE";
//                 e.target.style.color = "#C95EBE";
//               }
//             }}
//           >
//             Cancel
//           </button>

//           <button
//             onClick={onDelete}
//             disabled={loading || deleteSuccess}
//             style={{
//               width: "30%",
//               padding: "8px",
//               border: "1px solid rgba(0, 0, 0, 0.2)",
//               borderRadius: "6px",
//               fontSize: "15px",
//               fontFamily: "Outfit",
//               fontWeight: "500",
//               background: loading || deleteSuccess ? "rgba(226, 25, 25, 0.75)" : "transparent",
//               color: loading || deleteSuccess ? "white" : "#52525B",
//               cursor: loading || deleteSuccess ? "not-allowed" : "pointer",
//               transition: "all 0.2s ease",
//             }}
//             onMouseEnter={(e) => {
//               if (!loading && !deleteSuccess) {
//                 e.target.style.background = "rgba(226, 25, 25, 0.1)";
//                 e.target.style.borderColor = "rgba(226, 25, 25, 0.3)";
//                 e.target.style.color = "#E21919";
//               }
//             }}
//             onMouseLeave={(e) => {
//               if (!loading && !deleteSuccess) {
//                 e.target.style.background = "transparent";
//                 e.target.style.borderColor = "rgba(0, 0, 0, 0.2)";
//                 e.target.style.color = "#52525B";
//               }
//             }}
//           >
//             {loading ? "Deleting..." : deleteSuccess ? "Deleted" : "Delete"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DeleteModal;
import React from "react";
import { createPortal } from "react-dom";

const DeleteModal = ({
  isOpen,
  onClose,
  onDelete,
  fileName,
  loading,
  deleteSuccess,
  // Optional overrides so a caller can say exactly what is about to be deleted.
  title = "Are you sure you want to delete the selected item(s)?",
  message = "The selected item(s) will be removed from this folder. This action cannot be undone.",
}) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 z-[100] bg-black/40 backdrop-blur-sm flex items-center justify-center">
      <div className="document-popup-box-delete">
      <h2 style={{ margin: "20px 24px 0", textAlign: "center" }}>
        {title}
      </h2>
      <p style={{ width: "auto", margin: "10px 32px 0" }}>
        {message}
      </p>
        <div
          style={{
            display: "flex",
            gap: "8px",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          <button
            onClick={() => onClose(null)}
            disabled={loading || deleteSuccess}
            style={{
              width: "25%",
              padding: "8px",
              border: "1px solid #C95EBE",
              borderRadius: "6px",
              color: "#C95EBE",
              fontSize: "15px",
              fontFamily: "Outfit",
              fontWeight: "500",
              background: "transparent",
              cursor: loading || deleteSuccess ? "not-allowed" : "pointer",
              opacity: loading || deleteSuccess ? "0.5" : "1",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              if (!loading && !deleteSuccess) {
                e.target.style.background = "rgba(187, 66, 174, 0.1)";
                e.target.style.borderColor = "#C95EBE";
                e.target.style.color = "#C95EBE";
              }
            }}
            onMouseLeave={(e) => {
              if (!loading && !deleteSuccess) {
                e.target.style.background = "transparent";
                e.target.style.borderColor = "#C95EBE";
                e.target.style.color = "#C95EBE";
              }
            }}
          >
            Cancel
          </button>

          <button
            onClick={onDelete}
            disabled={loading || deleteSuccess}
            style={{
              width: "30%",
              padding: "8px",
              border: "1px solid rgba(0, 0, 0, 0.2)",
              borderRadius: "6px",
              fontSize: "15px",
              fontFamily: "Outfit",
              fontWeight: "500",
              background: loading || deleteSuccess ? "rgba(226, 25, 25, 0.75)" : "transparent",
              color: loading || deleteSuccess ? "white" : "#52525B",
              cursor: loading || deleteSuccess ? "not-allowed" : "pointer",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              if (!loading && !deleteSuccess) {
                e.target.style.background = "rgba(226, 25, 25, 0.1)";
                e.target.style.borderColor = "rgba(226, 25, 25, 0.3)";
                e.target.style.color = "#E21919";
              }
            }}
            onMouseLeave={(e) => {
              if (!loading && !deleteSuccess) {
                e.target.style.background = "transparent";
                e.target.style.borderColor = "rgba(0, 0, 0, 0.2)";
                e.target.style.color = "#52525B";
              }
            }}
          >
            {loading ? "Deleting..." : deleteSuccess ? "Deleted" : "Delete"}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default DeleteModal;